export class Notification {
   type: NotificationType;
   title: string;
   message: string;
   link: string;
   date: Date = new Date();
   seen: boolean = false;

   constructor(typeNotif: NotificationType, titleNotif: string, msgNotif: string, routeLink?: string, seenNotif = false) {
      this.type = typeNotif;
      this.title = titleNotif;
      this.message = msgNotif;
      this.link = routeLink;
      this.seen = seenNotif;
   }
}
export enum NotificationType {
   Peligro = 1,
   Informacion = 2,
   Advertencia = 3,
   Success = 4,
}
